import { MetricSelector } from '../../MetricSelector'
import { METRIC_OPTIONS } from '../../../hooks/useProfileAnalysisFilters'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'

interface TypeMetricControlProps {
  metricOption: RiskProfileMetricOption
  onMetricChange: (value: string) => void
}

export function TypeMetricControl({ metricOption, onMetricChange }: TypeMetricControlProps) {
  return (
    <div className="w-56">
      <MetricSelector
        value={metricOption.value}
        onValueChange={onMetricChange}
        label="Select metric"
        options={METRIC_OPTIONS}
      />
    </div>
  )
}
